import { IconChecklist16 } from '@warp-ds/icons/react/checklist-16';
import { IconFilter16 } from '@warp-ds/icons/react/filter-16';
import { Button } from '@warp-ds/react/components/button';
import { Modal } from '@warp-ds/react/components/modal';
import dynamic from 'next/dynamic';
import type { PropsWithChildren, ReactElement } from 'react';
import type { MapProps } from '../../map/interfaces';
import { thousandSeparated } from '../../util/formatting';

// Dynamically import the shared map component to avoid SSR issues
const DynamicMap = dynamic(() => import('shared/map/ClientSideMap'), {
    ssr: false,
    loading: () => (
        <div className="flex items-center justify-center s-bg-subtle w-full h-full">
            <span className="s-text-subtle">Laster kart...</span>
        </div>
    ),
});

export type ResultPageMapLayoutProps = {
    showFilters: boolean;
    toggleFilters: () => void;
    resultList: ReactElement;
    filters: ReactElement;
    numberOfOffers?: number;
    closeMapUrl: string;
};

export const ResultPageMapLayout = ({
    showFilters,
    toggleFilters,
    resultList,
    filters,
    numberOfOffers,
    closeMapUrl,
    children,
    ...rest
}: PropsWithChildren<ResultPageMapLayoutProps & MapProps>) => (
    <>
        <div className="flex flex-col md:flex-row result-page-map-container">
            <div className="flex flex-col result-page-map-sidebar">
                <div className="flex items-center justify-between p-16 border-b md:border-b-0 s-border">
                    <Button utility small href={closeMapUrl} className="flex items-center gap-8" data-testid="showListButton">
                        <IconChecklist16 />
                        Vis i liste
                    </Button>
                    {numberOfOffers ? (
                        <span className="text-14" data-testid="numberOfResults">
                            {thousandSeparated(numberOfOffers)} treff
                        </span>
                    ) : null}
                    <Button utility small onClick={toggleFilters} className="flex items-center gap-8" data-testid="toggleFilterButton">
                        <IconFilter16 />
                        Filter
                    </Button>
                </div>
                <div className="hidden md:block overflow-y-auto">{resultList}</div>
            </div>
            <div className="flex-1 relative">
                <DynamicMap {...rest} className="result-page-map">
                    {children}
                </DynamicMap>
            </div>
        </div>
        <Modal title="Endre filter" open={showFilters} right onDismiss={toggleFilters}>
            {filters}
        </Modal>
    </>
);
